module.exports = __webpack_public_path__ + "img/icon-settings.07ee2123.svg";